import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Container = styled.li(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: [
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.xxl}`,
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.xxl}`,
    ],
    position: 'relative',
  }),
);

export const Content = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
);

export const RaceInfo = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
  }),
);

export const Name = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '80px',
    marginRight: defaultTheme.spacing.s,
    '& > a': {
      marginBottom: defaultTheme.spacing.s,
    },
  }),
);

export const Date = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }),
);

export const VelodromeName = styled(Link)(() =>
  mq({
    display: 'block',
    fontSize: [
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
      defaultTheme.font.size.xl,
    ],
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.s,
    textDecorationLine: 'underline',
    ...hoverOpacity,
  }),
);

export const RaceNum = styled.p(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.l,
    ],
    fontWeight: 'bold',
    lineHeight: ['18px', '18px', '18px', '20px'],
    '& > span': {
      marginRight: defaultTheme.spacing.xs,
    },
  }),
);

export const Times = styled.p(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'row', 'row', 'row'],
    fontSize: [
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.s,
    ],
    lineHeight: '16px',
    marginTop: '2px',
    '& > span:first-of-type': {
      marginRight: defaultTheme.spacing.s,
    },
    '& time': {
      marginLeft: defaultTheme.spacing.xs,
    },
  }),
);

export const DeadLine = styled.span(() =>
  mq({
    color: defaultTheme.color.primary,
  }),
);

export const EntryCampaignLabel = styled(Link)(() =>
  mq({
    position: 'absolute',
    bottom: 0,
    left: 0,
    fontSize: '10px',
    fontWeight: 'bold',
    color: defaultTheme.color.primary,
    backgroundColor: '#FFEE00',
    padding: defaultTheme.spacing.xs,
  }),
);
